import React from 'react'
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventFlexiReportsChild from "./EventFlexiReportsChild";

const EventFlexiReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventFlexiReportsChild />
      </CardBackground>
    </MainTemplate>
  )
}

export default EventFlexiReports